import { setup } from 'xstate';

type Props = {
    direction: 'Left' | 'Both' | 'Right';
    isDecreasingDeleting: boolean;
    onDeletePhase: () => void;
    onDecreasePhaseLength: (direction: 'Left' | 'Right') => void;
    onIncreasePhaseLength: (direction: 'Left' | 'Right') => void;
};

export function createStateMachine({
    direction,
    isDecreasingDeleting,
    onDeletePhase,
    onDecreasePhaseLength,
    onIncreasePhaseLength,
}: Props) {
    return setup({
        types: {
            context: {} as {
                direction: 'Left' | 'Both' | 'Right';
                isDecreasingDeleting: boolean;
            },
            events: {} as
                | { type: 'Focus left button' }
                | { type: 'Blur left button' }
                | { type: 'Click left button' }
                | { type: 'Focus right button' }
                | { type: 'Blur right button' }
                | { type: 'Click right button' }
                | { type: 'Focus additional left minus button' }
                | { type: 'Focus additional right minus button' }
                | { type: 'Remove temporary phase left' }
                | { type: 'Remove temporary phase right' },
        },
        actions: {
            deletePhase: () => {
                onDeletePhase();
            },
            decreasePhaseLength: ({ context, event }) => {
                if (context.direction === 'Both') {
                    if (event.type === 'Click left button' || event.type === 'Remove temporary phase left') {
                        onDecreasePhaseLength('Left');
                    } else {
                        onDecreasePhaseLength('Right');
                    }
                } else {
                    onDecreasePhaseLength(context.direction);
                }
            },
            increasePhaseLength: ({ context, event }) => {
                if (context.direction === 'Both') {
                    if (event.type === 'Click left button') {
                        onIncreasePhaseLength('Left');
                    } else {
                        onIncreasePhaseLength('Right');
                    }
                } else {
                    onIncreasePhaseLength(context.direction);
                }
            },
        },
        guards: {
            isPhaseLength1: ({ context }) => context.isDecreasingDeleting,
            isLeftFromMain: ({ context }) => context.direction === 'Left',
            isMain: ({ context }) => context.direction === 'Both',
            isRightFromMain: ({ context }) => context.direction === 'Right',
        },
    }).createMachine({
        /** @xstate-layout N4IgpgJg5mDOIC5QFEIEsAuAFAFgQ1jAHU1owMBiAMQHsBjAV1gAIAnMABwBs86xmARgwwYaAOwDaABgC6iUBxqxMacfJAAPRABYATABoQAT0QAOAOwA6AJwBGAGz3zUgMy6L1l9YC+3w6kxcAmJSGAxLAEkxFTwuCmk5JBBFZQxVMXUtBFtnSzdXAFZdF3N7O2sC80MTbN1HS21rXV0pJtMC2wKC3390bHxCEjJwqJi4iVtEhSUVNSSshyk8lpcikrLbCqrjRBzzAst7XQKpR1s3T3sekAD+4KGwyOi02PjdKeSZtLnQBdz81bFUrlSrVRD2CyWc7ubROWGnVzXW5BQahciWAAyYAAZhhmOh2HRvmJLAARHF4BhcSi0RgsLg4vFCETiBLqFKzDLzRDmNyWUy2OpSYWbUzaFwuMHZDpWJybXR6MUlJF9FEhYaYxn4tCE4lkilUmn0JjMBm4wTCUSSSbsr7pTI8vkCoUi6xKyU7bKbKylAr2bRiv0C04qwIDdWPLHmglgInpfXYynU6jGlisNBQHBMy2s2S21L27kIXm6fmC+zCqSi8UemrnSqWcy2CymewlKQFaxSbShu6ojVRvExuPifUMjD8bGpyAUADCXDQdAA1qatcyrWykhziQ7sq0lqtrM4j52FeZTFLbNpNpZdM3z3prPYHMq-DdVeGHujB9rdfHyeOk7ThAFAAEJcAwrCrua665h826Fr8ZieFCAYnNoHbXgql6wlYOTym2BQeBCvZql+4Q-sOeoALS2MwU50jO86LiuZrZiykh5ludo-JouwdtYjb2JU1hHi0TR1JerSCS4gonGKEIVnopGfmiFFalR8a0fRwFgRBUFsRaHGbtMBa8VkpgoVe7TdphgraJeV5WHUfonAUslAip9xqZq0Y6rGeoANR0QxTBMQuy5sBmWZGRuXGmZyu62KcLiWB0T7aF0YrHJ4l45bewn+m2pjFGKXn9pGGn+SOJLBTpjEgeBkFRZm7FxfBPFckhCCmKYqU5Eejh6JsXa1rsLhSM5969domVVry5URuioE0BgOC-gF6SwAmSZGnS0FtXB+aJUW-raJYlZOZlR4BvYl6eFYk0CkcTbNIKi3kZYK1rRtNXbeSiaGim+3pq1sVHdxZldXxCBnRdIraOY11I62l7mOjULHFIZ5uuKCofT533rZp4jbXVhmhYQIHMZFhmwZxHVQ7ufUHJN3aPrNSNSBenrNi4piHFjzTmAqwqVATGpE79xJk3RFO6U1BlrjmDPHTup0Qg07kuBCth8+01iXr19hpeeDiI62xWmBLjxSyTYiyy1MWU+FLFO4dquQyd3Usxdzizbo1icxhPN1k4AtyjNwbNFcb7IqpkurcT1Uy5YdWg87Cv6e74Oewl6vdcJAsBrCE23cc2G8yLJtHCcdQWO4nY2+iABK0VDin-4GsmtImnTKsmZ8TNFiWZYulWuMSlKngCx5BSI0Hugo7YzfhG3YP2ztQO9-SyvGTaXsFzDo-OhWrrulKz7F6cxx9eWFbmKvljrzFm8A7twMmhnHuDwh5mOqWU+l1J5jWLOePInZrzCncE+AUT8X4dz-KOAC5AgINTnBFVie92pq0QjDZKXYIEVFEhKLsklPR9UEgbDC5gKiZWvLHXoYZvIagQdLLugF6phUatnfuxl4pD29jDSy-U0K2XnvZWwUpepWGdF0EUTYUbwPbuw0c2kXbU0wQdXOv9OpJQEkJESYlWjNFDogdKNh3LQnLG6YoyiN6dzUSFLOzU+E4MPngiyVlbpXkRuKWEUo-RWC7EcCs-NnAWG6HHD8LDHhsM3nVDRGC3bfx0QIv+0MFgpTSt6P0wpZrOkvrQmwN9nC2VKDkexr9HG1WcegxWOd6a6OHj7PqUJaFumrgqFw4opQi1kZAwUyVSEBngZwHgfAuFU2SZFdg3BeD8CaekvRRY8YNHWO4Eo7lHBT15nySsroJTinaGM+ZkykkNLmRMxZA9lktJhms8UpRNn7B1m2UBAo0oHIwk9f0R5fBvjEDQCAcB1Dx1ieQXB-8EDUTup6WF8MDntERnsf50TmEVXRKMF4XAoWZPBNsGoIslgnAfLNesllH7or7EtdSfkkHQwybubWyx2bYyvMUIiUk9Zj3nicc4SkezUrIj5SiNSt7Ujxcyz5+RZrsr0KsMx0psa3loacc8JUShPifmKhlY5UFTMgFKosBCDjpVbPsCEfociXiKEsOUTRFRPJ1VVPV6jgLGu6gQmuRQsotFhG6OFdYWhLF9P6QMusQzCoTpVelm1RyJI9R46F3rDi+qIv6soqM9kVkbNNNszhOzdifnbGp8Bk34oQLCc6pLOnCWvFAoNuxOy2HafKesRQXIlqTqoh2EqMCephh0UstaLD1qvHre6CoLruBfEc+e3afr20dvLBqg6LLzwKs2bmwJ-YOV5kHJYT0HBL0FHeXQi7k4MsdqkjR66zCNFVYCYUqxSinDRqYJYclsYLyVPjaNEK14qPtvehALLZUYTvAqrlnpHlWMbWUJediAOYqAw4vV79DSgaIq2iD8rOVKokjYTYGx56TUqNbFDtLn7AfFSgichqICgdNTko8E9+bNENp6IOuG5ILz0EjWhVTEHxpJO6tdFb9FPjTULUSmUWyXzvA0Upd5OjNlbMJ3tac6ncOY60H1smg5EXPH0mVgzoGWRIlRz6LdxkLMY6B44siuwi3gx2Js+6ai9QaA4Jwrh3C0K8AC7wQA */
        id: 'EditPhaseWidget',
        initial: 'Initial',
        context: {
            direction,
            isDecreasingDeleting,
        },
        states: {
            Initial: {
                always: [
                    {
                        guard: 'isLeftFromMain',
                        description: 'Edit phase widget controls a phase left to the main phase',
                        target: 'Left direction',
                    },
                    {
                        guard: 'isMain',
                        description: 'Edit phase widget controls the main phase',
                        target: 'Both directions',
                    },
                    {
                        guard: 'isRightFromMain',
                        description: 'Edit phase widget controls a phase right to the main phase',
                        target: 'Right direction',
                    },
                ],
            },

            'Left direction': {
                initial: 'Default',
                states: {
                    Default: {
                        on: {
                            'Focus left button': [
                                {
                                    guard: 'isPhaseLength1',
                                    target: 'Delete focused',
                                },
                                {
                                    target: '-1 focused',
                                },
                            ],
                            'Focus right button': {
                                target: '+1 focused',
                            },
                        },
                    },
                    'Delete focused': {
                        on: {
                            'Click left button': {
                                actions: 'deletePhase',
                                target: 'Delete focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '-1 focused': {
                        on: {
                            'Click left button': {
                                actions: 'decreasePhaseLength',
                                target: '-1 focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '+1 focused': {
                        on: {
                            'Click right button': {
                                actions: 'increasePhaseLength',
                                target: '+1 focused',
                            },
                            'Blur right button': {
                                target: 'Default',
                            },
                        },
                    },
                },
            },

            'Both directions': {
                initial: 'Default',
                states: {
                    Default: {
                        on: {
                            'Focus additional left minus button': {
                                target: '-1 left focused',
                            },
                            'Focus left button': {
                                target: '+1 left focused',
                            },
                            'Focus additional right minus button': {
                                target: '-1 right focused',
                            },
                            'Focus right button': {
                                target: '+1 right focused',
                            },
                        },
                    },
                    '-1 left focused': {
                        on: {
                            // This is a workaround to display the correct icon after the click (based on the target state) without having to change the state machine architecture
                            'Remove temporary phase left': {
                                actions: 'decreasePhaseLength',
                                target: 'Default',
                            },
                            'Click left button': {
                                actions: 'decreasePhaseLength',
                                target: '-1 left focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '+1 left focused': {
                        on: {
                            'Click left button': {
                                actions: 'increasePhaseLength',
                                target: '+1 left focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '-1 right focused': {
                        on: {
                            // This is a workaround to display the correct icon after the click (based on the target state) without having to change the state machine architecture
                            'Remove temporary phase right': {
                                actions: 'decreasePhaseLength',
                                target: 'Default',
                            },
                            'Click right button': {
                                actions: 'decreasePhaseLength',
                                target: '-1 right focused',
                            },
                            'Blur right button': {
                                target: 'Default',
                            },
                        },
                    },
                    '+1 right focused': {
                        on: {
                            'Click right button': {
                                actions: 'increasePhaseLength',
                                target: '+1 right focused',
                            },
                            'Blur right button': {
                                target: 'Default',
                            },
                        },
                    },
                },
            },

            'Right direction': {
                initial: 'Default',
                states: {
                    Default: {
                        on: {
                            'Focus left button': [
                                {
                                    guard: 'isPhaseLength1',
                                    target: 'Delete focused',
                                },
                                {
                                    target: '-1 focused',
                                },
                            ],
                            'Focus right button': {
                                target: '+1 focused',
                            },
                        },
                    },
                    'Delete focused': {
                        on: {
                            'Click left button': {
                                actions: 'deletePhase',
                                target: 'Delete focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '-1 focused': {
                        on: {
                            'Click left button': {
                                actions: 'decreasePhaseLength',
                                target: '-1 focused',
                            },
                            'Blur left button': {
                                target: 'Default',
                            },
                        },
                    },
                    '+1 focused': {
                        on: {
                            'Click right button': {
                                actions: 'increasePhaseLength',
                                target: '+1 focused',
                            },
                            'Blur right button': {
                                target: 'Default',
                            },
                        },
                    },
                },
            },
        },
    });
}
